const eventTypes = {
  activeDirectoryCreate: 'activedirectory_create',
  activeDirectoryDelete: 'activedirectory_delete',
  adminCreate: 'admin_create',
  adminDelete: 'admin_delete',
  adminLoginAttempt: 'admin_login_attempt',
  adminPasswordChange: 'admin_password_change',
  adminPasswordResetRequest: 'admin_password_reset_request',
  adminUpdate: 'admin_update',
  applicationCreate: 'application_create',
  applicationDelete: 'application_delete',
  applicationUpdate: 'application_update',
  associationChange: 'association_change',
  authnPolicyCreate: 'authnpolicy_create',
  authnPolicyDelete: 'authnpolicy_delete',
  authnPolicyUpdate: 'authpolicy_update',
  commandCreate: 'command_create',
  commandDelete: 'command_delete',
  commandResultDelete: 'commandresult_delete',
  commandRun: 'command_run',
  commandUpdate: 'command_update',
  deviceTrustUserLoginAttempt: 'device_trust_user_login_attempt',
  fileCreate: 'file_create',
  fileDelete: 'file_delete',
  fileUpdate: 'file_update',
  googleEmmCreate: 'google_emm_create',
  googleEmmDelete: 'google_emm_delete',
  googleEmmPatch: 'google_emm_patch',
  groupCreate: 'group_create',
  groupDelete: 'group_delete',
  groupUpdate: 'group_update',
  gsuiteDirectoryCreate: 'gsuite_directory_create',
  gsuiteDirectoryDelete: 'gsuite_directory_delete',
  gsuiteDirectoryUpdate: 'gsuite_directory_update',
  idSourceCreate: 'idsource_create',
  idSourceDelete: 'idsource_delete',
  idSourceUpdate: 'idsource_update',
  iplistCreate: 'iplist_create',
  iplistDelete: 'iplist_delete',
  iplistUpdate: 'iplist_update',
  integrationActivate: 'integration_activate',
  integrationattributeInclude: 'integrationattribute_include',
  integrationattributeExclude: 'integrationattribute_exclude',
  integrationDeactivate: 'integration_deactivate',
  invoiceDownload: 'invoice_download',
  ldapBind: 'ldap_bind',
  ldapSearch: 'ldap_search',
  loginAttempt: 'login_attempt',
  mdmCommandResult: 'mdm_command_result',
  notificationDelete: 'notification_delete',
  o365DirectoryCreate: 'o365_directory_create',
  o365DirectoryDelete: 'o365_directory_delete',
  o365DirectoryUpdate: 'o365_directory_update',
  organizationCreate: 'organization_create',
  organizationUpdate: 'organization_update',
  osMinorRollback: 'os_minor_rollback',
  osMinorUpgrade: 'os_minor_upgrade',
  osMajorRollback: 'os_major_rollback',
  osMajorUpgrade: 'os_major_upgrade',
  passwordManagerDisable: 'passwordmanager_disable',
  passwordManagerEnable: 'passwordmanager_enable',
  passwordManagerFolderCreate: 'passwordmanager_folder_create',
  passwordManagerFolderDelete: 'passwordmanager_folder_delete',
  passwordManagerFolderMemberAdd: 'passwordmanager_folder_member_add',
  passwordManagerFolderMemberRemove: 'passwordmanager_folder_member_remove',
  passwordManagerFolderMemberUpdate: 'passwordmanager_folder_member_update',
  passwordManagerItemAdd: 'passwordmanager_item_add',
  passwordManagerItemMove: 'passwordmanager_item_move',
  passwordManagerItemRemove: 'passwordmanager_item_remove',
  passwordManagerItemUpdate: 'passwordmanager_item_update',
  passwordManagerUserActivate: 'passwordmanager_user_activate',
  passwordManagerUserDeactivate: 'passwordmanager_user_deactivate',
  passwordManagerUserDevicePair: 'passwordmanager_user_device_pair',
  passwordManagerUserDeviceUnpair: 'passwordmanager_user_device_unpair',
  passwordManagerUserDisable: 'passwordmanager_user_disable',
  passwordManagerUserEnable: 'passwordmanager_user_enable',
  passwordManagerUserEnableAgain: 'passwordmanager_user_re-enable',
  passwordManagerUserReactivate: 'passwordmanager_user_reactivate',
  passwordManagerUserSignup: 'passwordmanager_user_signup',
  passwordManagerUserUpdate: 'passwordmanager_user_update',
  policyCreate: 'policy_create',
  policyDelete: 'policy_delete',
  policyUpdate: 'policy_update',
  radiusAuth: 'radius_auth',
  radiusAuthAttempt: 'radius_auth_attempt',
  radiusServerCreate: 'radiusserver_create',
  radiusServerDelete: 'radiusserver_delete',
  radiusServerUpdate: 'radiusserver_update',
  remoteSessionEnd: 'remote_session_end',
  remoteSessionFeedback: 'remote_session_feedback',
  remoteSessionJoin: 'remote_session_join',
  remoteSessionStart: 'remote_session_start',
  sambaDomainCreate: 'sambadomain_create',
  sambaDomainDelete: 'sambadomain_delete',
  sambaDomainUpdate: 'sambadomain_update',
  softwareAdd: 'software_add',
  softwareChange: 'software_change',
  softwareRemove: 'software_remove',
  ssoAuth: 'sso_auth',
  systemCreate: 'system_create',
  systemDelete: 'system_delete',
  systemFdeKeyDecrypt: 'system_fde_key_decrypt',
  systemFdeKeyUpdate: 'system_fde_key_update',
  systemUpdate: 'system_update',
  translationRuleCreate: 'translation_rule_create',
  translationRuleDelete: 'translation_rule_delete',
  trialResume: 'trial_resume',
  trialStart: 'trial_start',
  trialStop: 'trial_stop',
  userActivated: 'user_activated',
  userActivationEmail: 'user_activation_email',
  userActivationScheduleCreate: 'user_activation_schedule_create',
  userActivationScheduleDelete: 'user_activation_schedule_delete',
  userAdminGranted: 'user_admin_granted',
  userAdminRevoked: 'user_admin_revoked',
  userCreate: 'user_create',
  userDeactivated: 'user_deactivated',
  userDelete: 'user_delete',
  userDeleteProvision: 'user_delete_provision',
  userGroupAdminGrant: 'user_group_admin_grant',
  userGroupAdminRevoke: 'user_group_admin_revoke',
  userImportStarted: 'user_import_started',
  userImportCompleted: 'user_import_completed',
  userImportError: 'user_import_error',
  userLockout: 'user_lockout',
  userLoginAttempt: 'user_login_attempt',
  userMfaExclusionExpired: 'user_mfa_exclusion_expired',
  userPasswordChange: 'user_password_change',
  userPasswordExpired: 'user_password_expired',
  userPasswordResetRequest: 'user_password_reset_request',
  userPasswordSet: 'user_password_set',
  userPasswordWarningEmail: 'user_password_warning_email',
  userSuspended: 'user_suspended',
  userSuspensionScheduleCreate: 'user_suspension_schedule_create',
  userSuspensionScheduleDelete: 'user_suspension_schedule_delete',
  userUnlocked: 'user_unlocked',
  userUpdate: 'user_update',
  userUpdateProvision: 'user_update_provision',
  userUnsuspended: 'user_unsuspended',
  userCreateProvision: 'user_create_provision',
  workdayCreate: 'workday_create',
  workdayDelete: 'workday_delete',
  workdayUpdate: 'workday_update',
};

export const eventTypeNameMap = {
  [eventTypes.adminLoginAttempt]: 'Admin login attempt',
  [eventTypes.adminPasswordChange]: 'Admin password changed',
  [eventTypes.systemCreate]: 'System create',
  [eventTypes.systemDelete]: 'System delete',
  [eventTypes.associationChange]: 'Association change',
  [eventTypes.invoiceDownload]: 'Invoice download',
  [eventTypes.organizationUpdate]: 'Organizational update',
  [eventTypes.osMinorUpgrade]: 'OS minor upgrade',
  [eventTypes.osMajorUpgrade]: 'OS major upgrade',
  [eventTypes.osMinorRollback]: 'OS minor rollback',
  [eventTypes.osMajorRollback]: 'OS major rollback',
  [eventTypes.userActivated]: 'User activated',
  [eventTypes.userCreate]: 'User created',
  [eventTypes.userDelete]: 'User deleted',
  [eventTypes.userLockout]: 'User lockout',
  [eventTypes.userLoginAttempt]: 'User login attempt',
  [eventTypes.userPasswordChange]: 'User password change',
  [eventTypes.userPasswordExpired]: 'User password expired',
  [eventTypes.userPasswordSet]: 'User password set',
  [eventTypes.userSuspended]: 'User suspended',
  [eventTypes.userUnlocked]: 'User unlocked',
  [eventTypes.userUpdate]: 'User update',
};

export default eventTypes;
